import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { Shipping } from '../models/Shipping';

interface ShippingListItemProps {
  shipping: Shipping;
}

const ShippingListItem: React.FC<ShippingListItemProps> = ({
  shipping,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + shipping.jan.toLowerCase()}
    >
      <IonItem>
        <IonLabel>
          <h3 style={{ fontSize: '20px' }}>
            商品コード : {(shipping.jan !== "" && shipping.original_num !== "") ? `${shipping.jan} - ${shipping.original_num}` : shipping.jan + shipping.original_num}
          </h3>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文日 : {shipping.order_date},
            注文番号 : {shipping.order_num},
          </p>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            出荷番号 : {shipping.shipping_num}
            入庫棚番 : {shipping.rack_num}
            {(shipping.status === 1) ? " 出荷完了" : ""}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(ShippingListItem);
